import { callApi } from "./api";

// api services
export const addToCart = (
  design_id,
  quantity,
  comments,
  largePlate,
  proof,
  orderId
) => {
  let proofParam = "";

  if (proof === "CustomArtCharge") {
    proofParam = "&proof=custom_art";
  } else if (proof === "CustomArtProofCharge") {
    // this will signal its custom art WITH proof
    proofParam = "&proof=custom_art_proof";
  } else if (proof === "PhotoDigitalProofCharge") {
    proofParam = "&proof=photo";
  } else if (proof === "RegularDigitalProofCharge") {
    proofParam = "&proof=regular";
  }

  let orderIdParam =
    orderId && orderId.length > 0 ? "&order_id=" + orderId : "";

  const params = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    credentials: "include",
    method: "POST",
    body: `design_id=${design_id}&quantity=${quantity}&comments=${comments}&large_plate=${largePlate}${proofParam}${orderIdParam}`
  };

  let url = "add-design-to-cart";
  return callApi(url, params).then((response) => {
    if (response.response) {
      return { response: response.response };
    } else {
      return { error: response.error };
    }
  });
};
